<!-- //
ftp列表管理
@auth xuyd
@date 2025-07-20
//-->
<template>
  <page-layout layout="C">
    <!-- 检索区域 -->
    <div class="layout-search flex-row flex-halign-between">
      <el-form @submit.native.prevent ref="refQueryForm" :model="queryParams" size="small" :inline="true"
               label-width="100px">
        <el-form-item prop="search">
          <el-input
              v-model="queryParams.search"
              placeholder="请输入监控的服务名称/IP/日志路径"
              style="width: 320px;text-align: right;"
              maxlength="20"
              clearable
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery" icon="el-icon-search">检索</el-button>
          <el-button type="primary" plain @click="handleReset" icon="el-icon-refresh">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display:flex; justify-content: right;">
        <el-button size="small" type="primary" @click="handleAdd" icon="el-icon-plus">添加</el-button>
      </div>
    </div>

    <div class="layout-result" style="height: calc(100% - 63px);">
      <!-- 子table单选 -->
      <el-table  ref="refMainTable"
                 v-loading="tableData.tableLoading"
                 :data="tableData.records"
                 stripe
                 height="100%"
                 size="medium"
                 row-key="id"
                 :default-expand-all="true"
                 @select="handleMainSelect"
                 @select-all="handleMainSelectAll"
                 :header-cell-style="this.tableHeader">

        <el-table-column header-align="center"
                         align="center"
                         width="50"
                         type="selection"/>

        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form class="demo-table-expand" style="margin-left: 50px;">
              <el-table :ref="'refSingleSubTable' + props.row.id"
                        :data="props.row.investCodeAndNameS"
                        row-key="id"
                        stripe
                        size="mini">
                <el-table-column label="选择" width="80" header-align="center" align="center">
                  <template slot-scope="scope">
                    <el-radio v-model="props.row.selectSubRowId"
                              :label="scope.row.id"
                              class="hidden-label"
                              @change="handleSubSingleSelect(scope.row, props.row)">
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column label="ID" prop="id" width="80"></el-table-column>
                <el-table-column label="投资品Code" prop="investCode" width="100"></el-table-column>
                <el-table-column label="投资品名称" prop="investName" width="200"></el-table-column>
                <el-table-column label="项目Code" prop="projectCode" width="150"></el-table-column>
                <el-table-column label="子项目Code" prop="subProjectCode" width="150"></el-table-column>
                <el-table-column label="合计确认份额" prop="sumConfirmShares" width="150"></el-table-column>
              </el-table>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="ID" prop="id" width="80"></el-table-column>
        <el-table-column label="通道" prop="channelCode" width="100"></el-table-column>
        <el-table-column label="商品名称" prop="projectCode" width="300"></el-table-column>
        <el-table-column label="描述" prop="projectName" minWidth="200"></el-table-column>
      </el-table>
    </div>
  </page-layout>
</template>

<script>

const templateMainData = {
  "id": 1983,
  "channelCode": "nyt11983",
  "selectSubRowId": null,
  "projectCode": "WT2X",
  "projectName": "上信睿赢-兴证心选【1983】号家庭服务信托",
  "investCodeAndNameS":[]
};
const templateSubData = {
  "id": "1983-1",
  "investCode": "MM4500",
  "investName": "睿赢智管家产品",
  "projectCode": "WT2X",
  "subProjectCode": "WT2X1983",
  "sumConfirmShares": 10000.00
}
export default {
  name: 'ViewMonitorChannelList',
  components: {},
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
    {dictType: 'HEALTHY_STATUS', dataType: Number}, // 健康状态
  ],
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: null,
        isAsc: null,
        search: null,
        monitorStatus: [],
      },
      messages: [],
      eventSource: null,
      tableData: {
        tableLoading: false,
        records: [],
        total: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  destroyed() {
  },
  methods: {
    handleMainSelectAll(selectedRows) {
      // console.log("---handleParentSelectAll-----", selectedRows)
      // 全量勾选时候
      if(selectedRows && selectedRows.length > 0) {//设置所有子table选择
        selectedRows.forEach(row => {
          this.$nextTick(() => {
            row.selectSubRowId = row.investCodeAndNameS[0].id;
          })
        });
      } else {// 清除所有子table选择
        this.tableData.records.forEach(row => {
          this.$nextTick(() => {
            row.selectSubRowId = null;
          })
        })
      }
    },
    handleMainSelect(selectedRows, currRow) {
      // console.log("---handleParentSelect-----", selectedRows, currRow)
      // 当前行事件，如果当前行在list中，则是选择，否则未选择
      if(selectedRows && selectedRows.length > 0) {
        if(selectedRows.findIndex(item => item.id === currRow.id) >= 0) {// 选择
          this.$nextTick(() => {
            currRow.selectSubRowId = currRow.investCodeAndNameS[0].id;
          })
        } else {// 未选中
          this.$nextTick(() => {
            currRow.selectSubRowId = null;
          })
        }
      } else {// currRow的子table clear处理
        this.$nextTick(() => {
          currRow.selectSubRowId = null;
        });
      }
    },
    handleSubSingleSelect(currRow, parentRow) {
      // console.log("---sub selectionList currRow-----", currRow, parentRow)
      this.$nextTick(() => {
        const refTable = this.$refs['refMainTable'];
        if (refTable) {
          refTable.toggleRowSelection(parentRow, true)
        }
      });
    },

    /**
     * 列表数据查询
     */
    getList() {
      let records = [];
      let limit = 1000;
      let subLimit = 5;
      for(let i = 0; i < limit; i++) {
        let data = JSON.parse(JSON.stringify(templateMainData));
        data.id = i;
        for(let j = 0; j < subLimit; j++) {
          let subData = JSON.parse(JSON.stringify(templateSubData));
          subData.id = i + "-" + j;
          data.investCodeAndNameS.push(subData);
        }
        records.push(data);
      }
      // records = investData;
      // 初始化展示控制的字段数据
      this.tableData.records = records.map(item => {
            item.selectSubRowId = "";
            item.investCodeAndNameS.forEach(subItem => subItem.checked = '');
            return item;
          }
      );
      this.tableData.total = records.length * 2;// 模拟分页
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    handleReset() {
      this.resetForm("refQueryForm");
      this.$refs.refQueryForm.resetFields();
      this.queryParams.orderByColumn = null;
      this.queryParams.isAsc = null;
      // =========重置(S)========
      this.queryParams.monitorStatus = [];
      // =========重置(E)========
      this.handleQuery();
    },

    /** 排序触发事件 */
    handleSortChange(column) {
      // console.log("----handleSortChange---->", JSON.stringify(column));
      if (column.order === 'ascending') {
        this.queryParams.isAsc = true;
        this.queryParams.orderByColumn = column.prop;
      } else if (column.order === 'descending') {
        this.queryParams.isAsc = false;
        this.queryParams.orderByColumn = column.prop;
      } else {
        this.queryParams.isAsc = null;
        this.queryParams.orderByColumn = null;
      }
      this.getList();
    },
    handleAdd() {
    },

    handleEdit(row) {
    },
    handleCopy(row) {
    },

    /**
     * 查看详情
     * @param row
     */
    handleView(row) {
    },

  }
}
</script>

<style lang="less" scoped>

.hidden-label {
  :deep(.el-radio__label) {
    display: none;
  }
}
</style>
